import { render, staticRenderFns } from "./TkCovid19Notes.vue?vue&type=template&id=5712a0a8&scoped=true&"
import script from "./TkCovid19Notes.vue?vue&type=script&lang=js&"
export * from "./TkCovid19Notes.vue?vue&type=script&lang=js&"
import style0 from "./TkCovid19Notes.vue?vue&type=style&index=0&id=5712a0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712a0a8",
  null
  
)

export default component.exports